var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"action-area"}},[_c('div',{attrs:{"id":"action-area-container-place"}}),_c('div',{staticClass:"container",attrs:{"id":"action-area-container"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }